import Transformer from "../Transformer";

export default class CounterpartyTypeTransformer extends Transformer {
  static fetch(item) {
    const transformed = {
      code: item.code,
      globalId: item.globalId,
      shortName: item.shortName,
      fullName: item.fullName
    };
    return Object.freeze(transformed);
  }
}
